export const tonoiList = {
	ά: 'α',
	έ: 'ε',
	ό: 'ο',
	ώ: 'ω',
	ύ: 'υ',
	ί: 'ι',
	ή: 'η',

	Ά: 'α',
	Έ: 'ε',
	Ό: 'ο',
	Ώ: 'ω',
	Ύ: 'υ',
	Ί: 'ι',
	Ή: 'η',
};

export const replaceTonous = str => {
	if (!str?.length) {
		return '';
	}
	let newStr = '';
	for (let i = 0; i < str.length; i++) {
		const ltr = str.charAt(i).toLowerCase();
		newStr += tonoiList[ltr] || ltr;
	}

	return newStr;
};
